import React from "react";
import { useParams } from "react-router-dom";
import DocumentTable from "~/components/document-table/DocumentTable";
import PermissionGate from "~/components/PermissionGate";
import CustomeButton from "~/components/Button";
import EmptyDataView from "~/components/nodataview";
import { formatDate } from "~/utils/CSVFunctions";
import fileUploadLogo from "../../../assets/attachment-paperclip.svg";
import fileIcon from "../../../assets/empty-file.svg";

const ShareholderAttachmentTable = ({
  loading,
  isDataAvailable,
  files,
  setOpenDialog,
  rows,
  onPageChange,
  first,
  handleAttachmentDelete,
  onSortOrderChange,
  isFilterApplied,
  totalRecords,
  onRefetch,
}) => {
  const { shareholderId: id, entityId } = useParams();

  if (!isDataAvailable && !loading) {
    return (
      <div>
        <div className="flex flex-column justify-content-center align-items-center p-5">
          {isFilterApplied ? (
            <div className="flex flex-column justify-content-center align-items-center p-5 empty__dataview filter-empty-icon">
              <EmptyDataView
                Icon={<img src={fileIcon} alt="File Icon" />}
                Header="It looks like there are no results based on the filters you applied"
                Description="No matches were found. Please adjust your filters to improve your search."
              />
            </div>
          ) : (
            <div className="no-documents-uploaded-section w-full">
              <img
                src={fileUploadLogo}
                alt="file-upload"
                className="file-upload-logo"
              />
              <p className="add-new-entity-heading mb-0">
                No Documents uploaded yet
              </p>
              <p className="drag-drop-text m-0">
                {
                  "Upload supporting documents for this shareholder, such as ID or proof of address."
                }
              </p>
              <PermissionGate
                resource="shareholder"
                action="modify"
                resourceAttr={{ entity_id: entityId }}
              >
                <CustomeButton
                  label="Upload File"
                  icon="pi pi-upload"
                  iconPos="right"
                  onClick={() => setOpenDialog(true)}
                />
              </PermissionGate>
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <DocumentTable
      value={files ?? []}
      loading={loading}
      formatDate={formatDate}
      onDelete={handleAttachmentDelete}
      relatedId={id}
      relatedType="SHAREHOLDERS"
      totalRecords={totalRecords ?? 0}
      rows={rows ?? 10}
      first={first ?? 0}
      onPageChange={onPageChange}
      onSortOrderChange={onSortOrderChange}
      isFilterApplied={!!isFilterApplied}
      emptyMessage="No attachments found"
      onRefetch={onRefetch}
    />
  );
};

export default ShareholderAttachmentTable;
